export const Logo = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" role="img" aria-label="Xtreme Protection logo" data-testid="brand-logo">
        <path d="M24 3 L43 11 V26 C43 36.5 34.5 43 24 45 C13.5 43 5 36.5 5 26 V11 Z" fill="#0F1117" stroke="#4B5563" strokeWidth="2.5" />
        <path d="M16 16 L32 32 M32 16 L16 32" stroke="#E53E3E" strokeWidth="5" strokeLinecap="square" />
    </svg>
);
